import { Component } from '@theme/component';

class SanoAnnouncementComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.dataset.ready = 'true';
    if (this.refs.pause) this.refs.pause.hidden = false;
  }

  toggleAnimation() {
    const paused = this.dataset.paused !== 'true';
    this.dataset.paused = String(paused);
    this.refs.pause?.setAttribute('aria-pressed', String(paused));
  }
}

if (!customElements.get('sano-announcement-component')) {
  customElements.define('sano-announcement-component', SanoAnnouncementComponent);
}
